import { FormQuestionAutotaskComponent } from './form-question-autotask.component';

export default angular
  .module('sfMobile.component.question-autotask', [])
  .component('sfFormQuestionAutotask', FormQuestionAutotaskComponent).name;
